import { render } from "./DropboxInfo.vue?vue&type=template&id=2a30cce2&scoped=true"
import script from "./DropboxInfo.vue?vue&type=script&lang=js"
export * from "./DropboxInfo.vue?vue&type=script&lang=js"

import "./DropboxInfo.vue?vue&type=style&index=0&id=2a30cce2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a30cce2"]])

export default __exports__